<template>
  <v-row
    align="center"
  >
    <v-col
      cols="12"
      class="pl-6 pt-0"
      :class="{'d-none': colors.length == 1}"
    >
      <span class="font-weight-medium pb-2 fs-15">Couleurs disponibles <small v-if="reference.isOrderable">(cliquez pour sélectionner)</small></span>
      <br>
      <br>
      <Color
        v-for="color in colors" 
        :key="color.id"
        :color="color"
        @changeColor="changeColor"
      ></Color>
    </v-col>
    <v-col 
      cols="12" 
      v-if="reference.isOrderable"
    >
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left fs-15">Taille</th>
              <th class="text-left fs-15">P.U. HT</th>
              <th class="text-center fs-15">Quantités</th>
            </tr>
          </thead>
          <tbody>
            <Row
              v-for="size in reference.sizes" 
              :key="size.id" 
              :size="size"
              :reference="reference"
              :color="selectedColor"
            ></Row>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
    <v-col
      cols="12"
      class="pl-6 pt-0"
      v-else
    >
      <span class="font-weight-medium pb-2 fs-15">Tailles disponibles</span>
      <br>
      <br>
      {{ sizes }}
    </v-col>
    <v-col cols="12" v-if="reference.isOrderable">
      <v-row
        justify="center"
        align="center"
      >
        <v-col 
          cols="6"
          md="8"
          lg="6"  
        >
          <v-btn 
            color="success"
            class="mr-5" 
            @click="addToCart"
          >
            <v-icon right dark class="mr-2">mdi-cart</v-icon>
            Ajouter au panier
          </v-btn>
        </v-col>
        <v-col 
          cols="6"
          md="4"
          lg="6" 
          class="text-center text-sm-right"
        >
          <span class="fs-15">Total : <span class="font-weight-bold">{{ getTotal | toPrice(2, '€') }}</span></span>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      v-else
    >
      <v-btn 
        color="primary"
        class="ml-2 mt-10"
        @click.stop="openContactDialog('Demande de référence personnalisée')"
      >
        Demander ma référence personnalisée
      </v-btn>
    </v-col>
  </v-row>
  
</template>

<script>
  // COMPONENTS
  import Row from './Row'
  import Color from './Color'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { AUTH_LOGOUT } from '@/store/actions/auth'
  import { REMOVE_FROM_TMP_CART, ADD_TO_TMP_CART, ADD_TO_CART, UPDATE_PRICE } from '@/store/actions/cart'
  import { OPEN_CONTACT_DIALOG } from '@/store/actions/general'
  // MIXINS
  import utils from '@/mixins/utils'
  // REPOSITORIES
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  const ReferencesRepository = RepositoryFactory.get('references')
  // VUEX
  import { mapGetters } from 'vuex'

  export default {
    name: 'Table',

    mixins: [utils],

    components: { 
      Row, 
      Color,
    },
    
    data: () => ({
      colors: [],
      errors: [],
      selectedColor: {},
      isLoading: false,
      prices: {},
    }),
  
    props: {
      reference: Object,
    },

    computed: {
      ...mapGetters({
        getTotal: 'getTmpCartTotal',
      }),
      sizes() {
        return this.formatObject(this.reference.sizes, 'sizes', 'Aucun représentant affilié')
      },
    },

    watch: {
      selectedColor(newColor, oldColor) {
        if (newColor.id != oldColor.id) {
          EventBus.$emit('changeColor', newColor)
          let customerApiToken = this.$store.getters.getCustomer.apiToken
          ReferencesRepository
            .getReferenceColorPrices(this.$route.params.id, newColor.id, customerApiToken)
            .then(response => {
              this.prices = response.data
              EventBus.$emit(UPDATE_PRICE, response.data)
              this.$store.commit(RESET_TMP_CART)
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 403) {
                  this.$store
                    .dispatch(AUTH_LOGOUT)
                    .then(() => {
                      this.$router.push('/login')
                    })
                }
              }
            })
        }
      },
    },

    methods: {
      addToCart() {
        EventBus.$emit(ADD_TO_CART)
      },
      openContactDialog(subject = null) {
        EventBus.$emit(OPEN_CONTACT_DIALOG, subject)
      },
      async getReferenceColors(id) {
        this.isLoading = true
        let customerApiToken = this.$store.getters.getCustomer.apiToken
        await ReferencesRepository
          .getReferenceColors(id, customerApiToken)
          .then(response => {
            this.isLoading = false
            this.colors    = response.data
            this.changeColor(this.first(this.colors))
            EventBus.$emit(LOADED)
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 403) {
                this.$store
                  .dispatch(AUTH_LOGOUT)
                  .then(() => {
                    this.$router.push('/login')
                  })
              }
            }
          })
        await EventBus.$emit('changeColor', this.first(this.colors))
      },
      changeColor(color) {
        this.selectedColor = color
      },
    },

    created() {
      this.getReferenceColors(this.$route.params.id)
    },
  }
</script>

<style>
  .v-label {
    font-size: 13px !important;
  }
  .v-chip.outlined {
    border: 1px solid #333 !important;
  }
  .fs12 {
    font-size: 12px !important;
  }
  .fw-300 {
    font-weight: 300 !important;
  }
  .mb-20 {
    margin-bottom: 20px !important;
  }
  .mt-20 {
    margin-top: 20px !important;
  }
  .fs-15 {
    font-size: 15px !important;
  }
</style>